import styled from 'styled-components';
import { ACCENT_GRAY_100 } from '../../../core/colors';

export const Wrapper = styled.div`
	width: 100%;
	background-color: ${ACCENT_GRAY_100};
	display: flex;
	flex-flow: column nowrap;
`;

export const FooterTop = styled.div`
	width: 100%;
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: center;
	padding: 75px 0;
	font-family: Montserrant;
	scroll-margin-top: 100px;
`;

export const TopHeadingFont = styled.p`
	margin: 0;
	font-size: 20px;
	color: #2b2a28;
	margin-bottom: 10px;
	span {
		font-family: Montserrant-Black;
	}
`;

export const TopFont = styled.div`
	color: #2b2a28;
	margin: 0 32px;
	font-size: 12px;
	span {
		font-family: Montserrant-Bold;
	}
	@media screen and (max-width: 1100px) {
		text-align: center;
	}
	@media screen and (max-width: 500px) {
		width: 95%;
	}
`;

export const ContactPersonsContainer = styled.div`
	margin: 50px 0;
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
	@media screen and (max-width: 800px) {
		flex-flow: column nowrap;
	}
`;

export const BarsContainer = styled.div`
	margin: 0 26px;
	display: flex;
	flex-flow: column nowrap;
	width: 90px;
	div {
		width: 100%;
		height: 1px;
		background-color: #dbdbdb;
		margin: 8px 0;
	}
	@media screen and (max-width: 800px) {
		margin: 40px 0;
	}
`;

export const CardWrapper = styled.div`
	display: flex;
	flex-flow: column nowrap;
	background-color: #fff;
	border: 1px solid #dbdbdb;
	border-radius: 15px;
	padding: 8px;
	padding-bottom: 16px;
`;

export const CardImgContainer = styled.div`
	width: 300px;
	height: auto;
	img {
		border-radius: 10px;
	}
`;

export const CardNameFont = styled.div`
	font-weight: 600;
	color: #000;
	margin: 8px 8px;
	margin-top: 20px;
	font-size: 20px;
`;

export const CardGenericFont = styled.div`
	color: #000;
	margin: 4px 8px;
	font-size: 16px;
	line-height: 1;
`;

export const FooterBottom = styled.div`
	background-image: linear-gradient(45deg, #002962, #004583);
	height: 250px;
	display: flex;
	flex-flow: row nowrap;
	width: 100%;
	position: relative;
	&::before {
		content: '';
		background-image: linear-gradient(rgb(0 0 0 / 10%), transparent);
		width: 100%;
		display: block;
		position: absolute;
		height: 10px;
	}
	@media screen and (max-width: 800px) {
		flex-flow: column nowrap;
		height: auto;
	}
`;

export const FooterBottomSection = styled.div`
	display: flex;
	flex-flow: column nowrap;
	flex: 1;
	justify-content: center;
	align-items: center;
	&:first-child {
		padding-left: 100px;
	}
	svg {
		height: 70px;
		width: auto;
		fill: #d8e0eb;
	}
	@media screen and (max-width: 1000px) {
		&:first-child {
			padding-left: 30px;
		}
	}
	@media screen and (max-width: 800px) {
		&:nth-child(1) {
			padding: 40px 0;
		}
		&:nth-child(2) {
			padding: 20px 0;
		}
	}
`;

export const FooterBottomFont = styled.div`
	color: #d8e0eb;
	margin: 0;
	text-align: left;
	line-height: 1.3;
	font-weight: 400;
	font-size: 13px;
	padding: 0 16px;
	& > a {
		font-weight: 600;
		color: #d8e0eb;
		margin-left: 6px;
	}
	@media screen and (max-width: 800px) {
		text-align: center;
	}
`;

export const FooterTopContactsContainer = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	margin-top: 40px;
	@media screen and (max-width: 900px) {
		flex-flow: column;
		align-items: center;
	}
`;

export const FooterTopContactMail = styled.div`
	display: flex;
	align-items: center;
	width: 350px;
	justify-content: flex-end;
	padding-right: 30px;
	div {
		background-color: #0085c6;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 37px;
		height: 37px;
		border-radius: 50%;
		margin-right: 10px;
	}
	p {
		font-size: 16px;
		font-family: Montserrant-Bold;
		span {
			color: #0085c6;
		}
	}
	svg {
		width: 22px;
		height: 22px;
		fill: #fff;
	}
	@media screen and (max-width: 900px) {
		justify-content: center;
		padding-right: 0;
	}
`;

export const FooterTopContactsRightContainer = styled.div`
	display: flex;
	background-image: linear-gradient(90deg, #ffffffa1, transparent);
	padding: 20px;
	border-radius: 150px;
	width: 600px;
	@media screen and (max-width: 900px) {
		margin-top: 50px;
		width: auto;
	}
`;

export const FooterTopContactsRightCenterLogo = styled.div`
	position: relative;
	width: 145px;
	height: 145px;
	img {
		width: 145px;
		height: 145px;
	}
	svg {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 50px;
		height: auto;
		fill: #263574;
	}
	@media screen and (max-width: 900px) {
		width: 125px;
		height: 125px;
		img {
			width: 125px;
			height: 125px;
		}
		svg {
			width: 40px;
		}
	}
`;

export const FooterTopContactsLeftContainer = styled.div`
	margin-left: 30px;
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
`;

export const ContactPersonContainer = styled.div`
	display: flex;
	align-items: center;
	margin: 15px 0;
	p {
		margin: 0;
		font-family: Montserrant;
		line-height: 1.4;
	}
	& > div > p:nth-child(1) {
		font-family: Montserrant-Bold;
	}
`;

export const ContactPersonIcon = styled.div`
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background-color: #e1e1e1;
	margin-right: 10px;
	svg {
		width: 22px;
		height: 22px;
		fill: #fff;
	}
`;
